/* eslint-disable react/prop-types */
import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@material-ui/core";

import { Alert } from "@material-ui/lab";

const PlanDialog = (props) => {
  const { dialogOpen, onDialogClose } = props;

  const handleClose = (event, isCancelled) => {
    let reason = "approved";
    if (isCancelled) {
      reason = "cancelled";
    }
    if (onDialogClose) onDialogClose(event, reason);
  };

  return (
    <>
      <Dialog
        open={dialogOpen}
        onClose={(event, reason) => {
          if (onDialogClose) onDialogClose(event, reason);
        }}
      >
        <DialogContent>
          <Box>
            <Typography variant="subtitle1">
              Are you sure you want to populate the data from selected plan?
            </Typography>
            <Alert severity="warning" style={{ marginTop: "16px" }}>
              This will overwrite any existing data in the form below!
            </Alert>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={(e) => handleClose(e, false)}>
            Yes
          </Button>
          <Button color="primary" onClick={(e) => handleClose(e, true)}>
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PlanDialog;
